module.exports = __webpack_public_path__ + "img/9.df835ed0.jpg";